import {
  StoryblokServerComponent,
  storyblokEditable,
} from "@storyblok/react/rsc";

import type { PageContext } from "~lib/storyblok/page";

import type { EventPageBlok } from "./types";

type ArticlePageProps = {
  blok: EventPageBlok;
} & PageContext;

export function EventPage({ blok, ...context }: ArticlePageProps) {
  if (blok.isDisabled) {
    return <code className="flex p-lg">Article disabled for this market</code>;
  }

  return (
    <main {...storyblokEditable(blok)} data-page-type="event">
      {blok.body?.map(nestedBlok => (
        <StoryblokServerComponent
          blok={nestedBlok}
          key={nestedBlok._uid}
          {...context}
        />
      ))}
    </main>
  );
}
